import { LocFinanceNeeds } from "redux-models/reduxStateTypes";

export const mapApiToLocFinanceNeeds = (payload: any): LocFinanceNeeds => {
  if (!payload.blBackground) {
    return {
      financingAmount: undefined,
      financingNeed: undefined,
      averageMonthlySales: undefined,
      bankStatementBrokerFlowId: undefined,
    };
  }

  return {
    financingAmount: payload.financingAmount,
    financingNeed: payload.locBackground.financingNeed,
    averageMonthlySales: payload.locBackground.averageMonthlySales,
    bankStatementBrokerFlowId: payload.locBackground.bankStatementBrokerFlowId,
  };
};
